import React from 'react';
import Collapsible from 'react-collapsible';

export const Collapse = ({ ...props }) => <Collapsible {...props} overflowWhenOpen="visible" />;
